import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';

import PageLayout from '../_partials/PageLayout';
import { Spin } from "antd";
import './style.scss';
import { fetchFrames } from "../../../actions/mine_craft/framesActions";
import List from "../../mine_craft/Frames/_partials/_List";
import PageHeader from "src/componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import NavBarThree from "../../../componets/NavBarThree";
import { InboxOutlined, SettingOutlined } from "@ant-design/icons";
import { selectFrameIds, setNewGroupParams, setReorderIds } from "../../../store/mine_craft/framesSlice";
import Dropzone from "../../mine_craft/Frames/Dropzone";
import minecraftUrls from "../../../configs/mine_craft/minecraftUrls";
import { queryParams } from "../../../helpers/UrlHelpers";
import { useSearchParams } from "react-router-dom";
import Filter, {FilterInterface} from "../../../componets/Filter";
import Settings from "./Settings";

export interface PropsInterface {
  appId: 1 | 2;
}
const LIMIT = 42;

const NAV_ITEMS: {[index: number]: any} = {
  0: {
    id: 0,
    name: 'All',
    url: minecraftUrls.framesPath()
  },
  1: {
    id: 1,
    name: 'Static',
    slug: 'static',
    url: minecraftUrls.framesPath({ frame_type: 1 })
  },
  2: {
    id: 2,
    name: 'Animated',
    slug: 'animated',
    url: minecraftUrls.framesPath({ frame_type: 2 })
  }
};

const DEFAULT_ORDER_BY = 'order';

const Frames = ({ appId }: PropsInterface) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const status = useAppSelector(state => state.mineCraft.frames.status);
  const error = useAppSelector(state => state.mineCraft.frames.error);
  const ids = useAppSelector(selectFrameIds);
  const frame_type = queryParams.get(searchParams,'frame_type');
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const activeId = Object.values(NAV_ITEMS).find(e => e.url === minecraftUrls.framesPath({ frame_type: frame_type }))?.id || 0;
  const filterProps: FilterInterface = {};

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        app_id: appId,
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT,
        frame_type: frame_type
      },
      ['order_by', 'order', 'date_from', 'date_to'],
      { 'order_by': DEFAULT_ORDER_BY }
    );

    dispatch(fetchFrames(params));
  }, [dispatch, appId, frame_type, currentPage, searchParams]);

  function onClickGroupCreate() {
    const params: any = { app_id: appId };
    params.frame_type = NAV_ITEMS[activeId]?.slug || 'static';

    dispatch(setNewGroupParams(params));
  }

  function onSettings() {
    dispatch(setReorderIds({ ids }));
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  filterProps.orderBy = {
    defaultKey: DEFAULT_ORDER_BY,
    defaultSort: 'asc',
    items: [
      { name: 'Order', key: 'order' },
      { name: 'Date', key: 'id' },
    ]
  };

  function renderSettingButton() {
    return (
      <NavBarThree>
        <NavBarThree.Button onClick={onSettings}>
          <SettingOutlined /> Frame Settings
        </NavBarThree.Button>
      </NavBarThree>
    );
  }

  return (
    <PageLayout>
      <PageHeader
        title='Frames'
        navs={NAV_ITEMS}
        activeId={activeId}
      >
        {frame_type && renderSettingButton()}
      </PageHeader>

      <Wrapper>
        <NavBarThree>
          <NavBarThree.Button className='v-link2' onClick={onClickGroupCreate}>
            <InboxOutlined /> Frames Dropzone
          </NavBarThree.Button>
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            dateRange
            {...filterProps}
          />
        </Wrapper>

        <List limit={LIMIT} pagination={true} />
      </div>

      <Dropzone />
      <Settings />
    </PageLayout>
  );
}

export default Frames;
